export const experienceData = [
    {
        id: 1,
        company: 'Panacloud',
        jobtitle: 'Frontend Developer',
        startYear: '2018',
        endYear: '2020'
    },
    {
        id: 2,
        company: 'Greyloops',
        jobtitle: 'Fullstack Developer',
        startYear: '2021',
        endYear: '2022'
    },
    {
        id: 3,
        company: 'Purelogics',
        jobtitle: 'Fullstack Developer',
        startYear: '2022',
        endYear: 'Present'
    },
]